import { render, staticRenderFns } from "./NearQuestions.vue?vue&type=template&id=e88d22b2&scoped=true&"
import script from "./NearQuestions.vue?vue&type=script&lang=js&"
export * from "./NearQuestions.vue?vue&type=script&lang=js&"
import style0 from "./NearQuestions.vue?vue&type=style&index=0&id=e88d22b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88d22b2",
  null
  
)

export default component.exports